/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListProvidersResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'Provider',
        },
      },
    },
  }],
} as const;
